<script src="https://cdn.tailwindcss.com"></script>
<template>
  <div class="content">
    <v-card>
      <v-tabs v-model="currentTabIndex" background-color="#e2007a" dark>
        <v-tab v-for="tab in tabs" :key="tab" :value="tab">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>

    <Segur v-if="currentTab === 'Segur Liste'"></Segur>
    <SegurBon v-if="currentTab === 'Segur Création'"></SegurBon>
    <Segurasp v-if="currentTab === 'Segur ASP'"></Segurasp>
    <SegurStats v-if="currentTab === 'Statistiques'"></SegurStats>
    <SegurDoc v-if="currentTab === 'Documentation'"></SegurDoc>
    <SegurArchives v-if="currentTab === 'Archives V1'"></SegurArchives>
    <SegurExclusions v-if="currentTab === 'Exclusions'"></SegurExclusions>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import store from "@/store";
import SegurBon from "./Segurbon.vue";
import Segur from "./Segur.vue";
import Segurasp from "./Segurasp.vue";
import SegurStats from "./SegurStats.vue";
import SegurDoc from "./SegurDoc.vue";
import SegurArchives from "./SegurArchives.vue";
import SegurExclusions from "./SegurExclusions.vue";

export default {
  name: "Segurmain",
  components: {
    SegurBon,
    Segur,
    Segurasp,
    SegurStats,
    SegurDoc,
    SegurArchives,
    SegurExclusions,
  },
  data: function () {
    const pc = localStorage.getItem("partnerCode");
    const isProkov = !pc || pc === "prokov";
    // Partenaires avec un historique V1 importe (BDC legacy avant V2).
    const hasV1Archive = isProkov || pc === "ict";
    // Onglet visible pour qui a accès au Ségur (CONTROL_SEGUR ou CONTROL_PARTENAIRE).
    // getDroits est une chaine concaténée ; match sous-chaine comme getRules.
    const droits = store.getters["authentification/getDroits"] || "";
    const canSegur =
      droits.includes("CONTROL_SEGUR") || droits.includes("CONTROL_PARTENAIRE");
    const tabs = ["Segur Liste", "Segur Création", "Segur ASP", "Statistiques"];
    if (!isProkov) tabs.push("Documentation");
    if (hasV1Archive) tabs.push("Archives V1");
    if (canSegur) tabs.push("Exclusions");
    return {
      currentTabIndex: 0,
      isProkov,
      tabs,
    };
  },
  computed: {
    currentTab() {
      return this.tabs[this.currentTabIndex];
    },
  },
  created: function () {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
